module.exports = __webpack_public_path__ + "img/shipmate--icon.37d08ca0.svg";